import Vue from 'vue'
import Vuex from 'vuex'
import offlinePay from "./modules/offlinePay.js" // 原生登录状态存储

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    offlinePay
  }
})